.react-autosuggest {
  &__container {
    position: relative;
  }

  &__suggestions-container {
    display: none;

    &--open {
      display: block;
      overflow-y: auto;

      position: absolute;
      top: calc(100% + var(--ds-size-1));
      width: 100%;
      max-height: 200px;
      box-sizing: border-box;
      z-index: 2;

      font-size: var(--ds-font-size-4);
      background-color: var(--ds-color-surface-default);
      border: 1px solid var(--ds-color-border-default);
      border-radius: var(--ds-border-radius-md, 4px);
      box-shadow: var(--ds-shadow-medium, 0 2px 10px rgba(0, 0, 0, 0.25));
    }
  }

  &__suggestions-list {
    list-style: none;
    padding: var(--ds-size-1) 0;
    margin: 0;
  }

  &__suggestion {
    display: block;
    cursor: pointer;
    box-sizing: border-box;
    padding: var(--ds-size-2) var(--ds-size-3);
    width: 100%;

    &:hover,
    &--highlighted {
      background-color: var(--ds-color-primary-background-tinted);
    }
  }
}
